import React, { useEffect, useState } from "react";
// CSS 모듈 import 방식으로 변경
import styles from "./PDO.module.css";
import PDOModel from "./PDOModel";
// 🚨 안 쓰는 axios와 react-router-dom 임포트 삭제 (앱이 훨씬 가벼워집니다)
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

// props 대신 { num, search, returnFalse }로 구조 분해 할당하여 코드를 깔끔하게 만듭니다.
function PDO({ num, search, returnFalse }) {
    const [visibleFirst, setVisibleFirst] = useState(true);
    // 초기값을 비워두어 데이터를 받아오기 전에는 아무것도 안 그리게 합니다.
    const [category, setCategory] = useState([]); 

    useEffect(() => {
        const reqOption = {
            method: "GET",
            headers: {
                "content-type": "application/json"
            }
        };

        fetch("/api/GetPDOCategory", reqOption)
            .then((response) => response.json())
            .then(data => {
                setCategory(data);
            })
            .catch(err => console.error("Category fetch error:", err)); // 에러 처리 추가
            
    // ★ 핵심 수정: 백엔드 API가 검색어(search)를 사용하지 않으므로 빈 배열 [] 로 바꿨습니다.
    // 이제 타자를 칠 때마다 서버에 무의미한 카테고리 요청을 보내지 않습니다.
    }, []); 

    // 삼항 연산자를 사용해 코드를 간결하게 줄였습니다.
    const checkZero = (n) => (n === 0 || !n ? '' : `(${n})`);

    return (
        <>
            {/* 타이틀 전체 영역에 onClick을 하나만 걸어서 클릭 범위를 넓히고 코드를 줄였습니다. */}
            <div className={styles.title} onClick={() => setVisibleFirst(!visibleFirst)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img 
                        className={visibleFirst ? styles.minusImg : styles.plusImg} 
                        src={visibleFirst ? downTriangleIcon : sideTriangleIcon} 
                        alt="toggleIcon" 
                    />
                </span>
                <span className={styles.pdoModels}>
                    PDO Models
                </span>
                <span className={styles.PDOnumber}>{checkZero(num?.num)}</span>
            </div>

            {/* map 안에서 매번 검사하지 않고, 밖에서 한 번만 조건부 렌더링을 겁니다. */}
            {visibleFirst && (
                <div className={styles.pdoBox}>
                    {category.map((map, index) => (
                        <PDOModel 
                            name={map.category} // 비어있는 카테고리('')도 정상적으로 name에 전달됩니다.
                            search={search} 
                            returnFalse={returnFalse} // 래퍼 함수 없이 부모의 함수를 바로 넘깁니다.
                            key={`pdo-model-${index}`} 
                        />
                    ))}
                </div>
            )}
        </>
    );
}

export default PDO;